import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';

function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title,
  contentText, // Can be a string or React node
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'primary', // 'primary', 'secondary', 'error', etc.
  loading = false // Optional loading state for the confirm button
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof contentText === 'string' ? (
          <Typography>{contentText}</Typography>
        ) : (
          contentText // Render React node directly
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
